import {APP_INITIALIZER, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DrawerModule, LayoutModule} from "@progress/kendo-angular-layout";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {ICON_SETTINGS, IconsModule} from "@progress/kendo-angular-icons";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {GiiRegistracijaComponent} from "./gii-registracija/gii-registracija.component";
import {ButtonModule} from "@progress/kendo-angular-buttons";
import {LabelModule} from "@progress/kendo-angular-label";
import {DropDownsModule} from "@progress/kendo-angular-dropdowns";
import {InputsModule} from "@progress/kendo-angular-inputs";
import {GridModule} from "@progress/kendo-angular-grid";
import {DatePipe, registerLocaleData} from "@angular/common";
import '@progress/kendo-angular-intl/locales/lt/all';
import lt from '@angular/common/locales/lt';
import en from '@angular/common/locales/en';
import {AppInitializer} from "./service/app-initializer.service";
import {DialogModule, WindowModule} from "@progress/kendo-angular-dialog";
import {RegPerziuraComponent} from "./gii-registracija/reg-perziura/reg-perziura.component";
import {LanguageService} from "./service/language.service";
import {KlasifikatoriusService} from "./service/klasifikatorius.service";
import {SessionTimerInterceptor} from "./service/session-timer-interceptor.service";
import { NotificationModule } from "@progress/kendo-angular-notification";
import { KlasifikatoriusComponent } from './klasifikatorius/klasifikatorius.component';
import {KlasifikatoriusEditService} from "./service/klasifikatorius-edit.service";
import {GiiApskaitaComponent} from './gii-apskaita/gii-apskaita.component';
import {FormsModule} from '@angular/forms';
import {DatePickerModule} from "@progress/kendo-angular-dateinputs";
import {ReactiveFormsModule} from "@angular/forms";
import {AtaskPerziuraPilnaComponent} from './gii-apskaita/atask-perziura-pilna/atask-perziura-pilna.component';
import {AtaskPerziuraComponent} from './gii-apskaita/atask-perziura-pilna/atask-perziura.component';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { PalygVmiAtaskaitaComponent } from './reports/gii-reports.component';
import {PDFExportModule} from "@progress/kendo-angular-pdf-export";
import {TranslateNamePipe} from "./utils/translate-name.pipe";


registerLocaleData(lt);
registerLocaleData(en);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    GiiRegistracijaComponent,
    RegPerziuraComponent,
    KlasifikatoriusComponent,
    GiiApskaitaComponent,
    AtaskPerziuraPilnaComponent,
    AtaskPerziuraComponent,
    PalygVmiAtaskaitaComponent,
    TranslateNamePipe
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        DrawerModule,
        NotificationModule,
        ExcelExportModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        ButtonModule,
        LabelModule,
        DropDownsModule,
        InputsModule,
        GridModule,
        WindowModule,
        LayoutModule,
        IconsModule,
        FormsModule,
        DatePickerModule,
        ReactiveFormsModule,
        DialogModule,
        PDFExportModule,
    ],
  providers: [
    AppInitializer,
    DatePipe,
    LanguageService,
    KlasifikatoriusService,
    KlasifikatoriusEditService,
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitializer: AppInitializer) => () => appInitializer.initialize(),
      deps: [AppInitializer],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionTimerInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: "lt-LT"
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
